import {lazyComponent} from 'coreUtils/adapters/lazy';

const AddressPopup = lazyComponent(() => import('./AddressPopup'));

export {AddressPopup as default};
